import { useRouterState } from "@tanstack/react-router";

export type PageTheme = "light" | "dark";

const DEFAULT_THEME: PageTheme = "dark";

/**
 * Resolves the theme for the current page from the leaf route's `staticData.theme`,
 * falling back to `dark`. The theme only applies once the route has loaded successfully,
 * so error / not-found states keep the default `dark` theme. Used by the layout and header
 * to recolor the whole page.
 */
export const usePageTheme = (): PageTheme =>
	useRouterState({
		select: (state) => {
			const leafMatch = state.matches[state.matches.length - 1];

			if (leafMatch?.status !== "success") {
				return DEFAULT_THEME;
			}

			return leafMatch.staticData.theme ?? DEFAULT_THEME;
		},
	});
